var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealthIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f186e233-30cd-46fe-adb3-851f9e211802",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140.56 140.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M86.75,55.63H51.59a2.94,2.94,0,0,1-2.94-2.93V27A16.64,16.64,0,0,1,65.27,10.34h7.79A16.64,16.64,0,0,1,89.68,27V52.7a2.93,2.93,0,0,1-2.93,2.93Z",
    style: {
      fill: "#f29481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.06,130.23H65.27a16.64,16.64,0,0,1-16.62-16.62V87.86a2.94,2.94,0,0,1,2.94-2.93H86.75a2.93,2.93,0,0,1,2.93,2.93v25.75a16.64,16.64,0,0,1-16.62,16.62Z",
    style: {
      fill: "#e97e6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5,90.79H25.84A16.63,16.63,0,0,1,9.22,74.18V66.39A16.64,16.64,0,0,1,25.84,49.77H112.5a16.63,16.63,0,0,1,16.61,16.62v7.79A16.63,16.63,0,0,1,112.5,90.79Z",
    style: {
      fill: "#f8beac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5,90.79H48.65l41-41H112.5a16.63,16.63,0,0,1,16.61,16.62v7.79A16.63,16.63,0,0,1,112.5,90.79Z",
    style: {
      fill: "#f29481"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.87,
    cy: 64.42,
    r: 2.93,
    style: {
      fill: "#edf5fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.87,
    cy: 76.14,
    r: 2.93,
    style: {
      fill: "#edf5fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.59,
    cy: 64.42,
    r: 2.93,
    style: {
      fill: "#edf5fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.59,
    cy: 76.14,
    r: 2.93,
    style: {
      fill: "#edf5fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.46,
    cy: 64.42,
    r: 2.93,
    style: {
      fill: "#d6e8f8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.46,
    cy: 76.14,
    r: 2.93,
    style: {
      fill: "#d6e8f8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.74,
    cy: 64.42,
    r: 2.93,
    style: {
      fill: "#d6e8f8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.74,
    cy: 76.14,
    r: 2.93,
    style: {
      fill: "#d6e8f8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.03,
    cy: 115.58,
    r: 2.93,
    style: {
      fill: "#d6e8f8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.31,
    cy: 115.58,
    r: 2.93,
    style: {
      fill: "#d6e8f8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.03,
    cy: 103.86,
    r: 2.93,
    style: {
      fill: "#d6e8f8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.31,
    cy: 103.86,
    r: 2.93,
    style: {
      fill: "#d6e8f8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.03,
    cy: 24.99,
    r: 2.93,
    style: {
      fill: "#edf5fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.31,
    cy: 24.99,
    r: 2.93,
    style: {
      fill: "#edf5fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.03,
    cy: 36.71,
    r: 2.93,
    style: {
      fill: "#edf5fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.31,
    cy: 36.71,
    r: 2.93,
    style: {
      fill: "#edf5fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.55,79.07H57.78a2.93,2.93,0,0,1-2.93-2.93V64.42a2.93,2.93,0,0,1,2.93-2.93H80.55a2.93,2.93,0,0,1,2.93,2.93V76.14a2.93,2.93,0,0,1-2.93,2.93Z",
    style: {
      fill: "#edf5fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.55,79.07H60.38L78,61.49h2.59a2.93,2.93,0,0,1,2.93,2.93V76.14a2.93,2.93,0,0,1-2.93,2.93Z",
    style: {
      fill: "#d6e8f8"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthIcon);
export default __webpack_public_path__ + "static/media/health-icon.8fc683ca1e00ca56c1c68ae88ed3ee9d.svg";
export { ForwardRef as ReactComponent };